<div class="group-services-dialog">
  <div class="group-services-dialog__header">
    <h2 class="group-services-dialog__title">{{ group?.name }}</h2>
  </div>

  <div class="group-services-dialog__body">
    <div class="group-services-dialog__list">
      @for (service of group?.eventTypes; track service.id) {
        <div
          class="group-services-dialog__item"
          [class.group-services-dialog__item--selected]="isMultiSelect ? isServiceChecked(service) : selectedService?.id === service.id"
          [class.group-services-dialog__item--disabled]="isDisabled(service)"
          [class.group-services-dialog__item--unavailable]="isEventUnavailable(service)"
          (click)="isMultiSelect ? onToggleService(service) : onSelectService(service)"
        >
          <div class="group-services-dialog__item-radio">
            @if (isMultiSelect) {
              <mat-checkbox
                [checked]="isServiceChecked(service)"
                [disabled]="isDisabled(service)"
                (click)="$event.stopPropagation()"
                (change)="onToggleService(service)"
              ></mat-checkbox>
            } @else {
              <mat-radio-button
                [checked]="selectedService?.id === service.id"
                [disabled]="isDisabled(service)"
                (click)="$event.stopPropagation()"
                (change)="onSelectService(service)"
              ></mat-radio-button>
            }

            <div class="group-services-dialog__item-info">
              <span class="group-services-dialog__item-name">
                {{ service.name }}
                @if (isEventUnavailable(service)) {
                  <glxy-badge color="yellow" size="small">Currently unavailable</glxy-badge>
                }
              </span>
              @if (service.description) {
                <span class="group-services-dialog__item-description" [title]="service.description">{{ service.description }}</span>
              }
            </div>

            <div class="group-services-dialog__item-details">
              <span class="group-services-dialog__item-duration">{{ durationMinutes(service.duration) }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="group-services-dialog__actions">
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!hasSelection"
      (click)="onAdd()"
    >
      {{ hasPreSelection ? 'Update' : 'Add' }}
    </button>
  </div>
</div>
